import React, { useState } from 'react';
import { EntityTable } from './EntityTable';
import { useEntities } from '../../hooks/useEntities';
import { getEntityConfig, type RelatedEntityConfig } from '../../lib/entity-config';

interface RelatedEntitiesTabsProps {
  parentId: string;
  relatedEntities: RelatedEntityConfig[];
}

function RelatedTab({ parentId, config }: { parentId: string; config: RelatedEntityConfig }) {
  const entityConfig = getEntityConfig(config.entityName);
  const filter = { [config.foreignKey]: parentId };
  const { records, isLoading } = useEntities(config.entityName, filter);

  if (!entityConfig) return null;

  return (
    <EntityTable
      columns={entityConfig.listColumns}
      records={records}
      entityName={config.entityName}
      primaryKeyField={entityConfig.primaryKeyField}
      isLoading={isLoading}
    />
  );
}

export function RelatedEntitiesTabs({ parentId, relatedEntities }: RelatedEntitiesTabsProps) {
  const [activeTab, setActiveTab] = useState(0);

  if (!relatedEntities.length) return null;

  return (
    <div className="mt-8 mb-12">
      <div className="border-b border-slate-200">
        <nav className="flex gap-0 overflow-x-auto" role="tablist">
          {relatedEntities.map((rel, idx) => (
            <button
              key={rel.entityName}
              role="tab"
              aria-selected={idx === activeTab}
              onClick={() => setActiveTab(idx)}
              className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                idx === activeTab
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              }`}
            >
              {rel.displayName}
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-4">
        <RelatedTab
          key={relatedEntities[activeTab].entityName}
          parentId={parentId}
          config={relatedEntities[activeTab]}
        />
      </div>
    </div>
  );
}
